const styles = (theme) => ({
    wrapper: {
        backgroundColor: theme.palette.primary.main,
        minHeight: '100vh',
        position: 'fixed',
        width: 240,
        zIndex: 999,
    },
    imgBox: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    logo: {
        width: 200,
        paddingTop: 15,
        paddingBottom: 15,
        margin: '0 auto',
    },
    lscLogo: {
        width: 180,
        paddingBottom: 45,
        margin: '0 auto',
    },
    logoPlaceholder: {
        width: 200,
        height: 45,
        paddingTop: 15,
        paddingBottom: 15,
        margin: '0 auto',
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        borderRadius: 4,
        animation: 'pulse 1.5s ease-in-out infinite',
    },
    '@keyframes pulse': {
        '0%': {
            opacity: 1,
        },
        '50%': {
            opacity: 0.5,
        },
        '100%': {
            opacity: 1,
        },
    },
});

export default styles;
